const config = Object.assign({}, window.appLocalizer);

export function getNonce() {
	return config.nonce;
}
export function getConfig() {
	return config.config;
}
export function adminAjax() {
	return config.adminAjax;
}
